<app-identity-validation-modal
  [open]="showIdentityValidationModal"
  [closable]="identityModalClosable"
  (openChange)="onIdentityModalOpenChange($event)"
  (paymentRequested)="goToPayment()"
  (networkRequested)="goToNetwork()"
  (logoutRequested)="logout()">
</app-identity-validation-modal>
